import { useEffect, useState } from "react"
import { InputProps } from "./Input";


export default function StringInput(props: InputProps) {
    const [value, setValue] = useState(props.value ? props.value as string: '');

    useEffect(() => {
        props.onChange(value);
    }, [value])

    return <div>
        <label>{props.content.title} </label> 
        <input type={props.content.type} required={props.required} className="template-field" maxLength ={240} value={value} onChange={(e) => {setValue(e.target.value)}} onInput={(e) => {
            setValue(e.currentTarget.value);
        }}></input>
    </div>
}